export default __webpack_public_path__ + "static/Prom_CAPABILITY_STATEMENT_Visiomate-1e9107e3bcf1b99814c93b6faf4c398d.pdf";